import React, { useState } from "react";
import { Link } from "react-router-dom";

import { StyledAnchor } from "./_.styled";
import OtherLanguagesSelector from "../OtherLanguagesSelector";
import OtherLanguagesDropdown from "../OtherLanguagesDropdown";

const OtherLanguagesContainer = ({ languageList }) => {
  let itemLabel = "unknown";
  languageList.forEach((item) => {
    if (item.isCurrentLanguage) {
      itemLabel = item.language;
    }
  });

  const [isOpen, setOpen] = useState(false);

  const toggleExpand = (evt) => {
    evt.preventDefault();
    setOpen(!isOpen);
  };

  const handleItemBlur = (evt) => {
    if (
      !evt.currentTarget.nextElementSibling.contains(
        evt.relatedTarget
      )
    ) {
      setOpen(false);
    }
  };

  const handleDropdownBlur = (evt) => {
    if (
      !evt.currentTarget.contains(
        evt.relatedTarget
      )
    ) {
      setOpen(false);
    }
  };

  return (
    <OtherLanguagesSelector
      label={itemLabel}
      onClick={toggleExpand}
      onBlur={handleItemBlur}
      isOpen={isOpen}
    >
      <OtherLanguagesDropdown isOpen={isOpen} onBlur={handleDropdownBlur}>
        {languageList.map((item) => (
          <StyledAnchor
            linkComponent={Link}
            href={item.slug.metadata.slug}
            fontSize="sm"
          >
            {item.language}
          </StyledAnchor>
        ))}
      </OtherLanguagesDropdown>
    </OtherLanguagesSelector>
  );
};

OtherLanguagesContainer.displayName = "OtherLanguagesContainer";

export default OtherLanguagesContainer;
